import { render, staticRenderFns } from "./DimEditTable.vue?vue&type=template&id=6b9a6bd2&"
import script from "./DimEditTable.vue?vue&type=script&lang=ts&"
export * from "./DimEditTable.vue?vue&type=script&lang=ts&"
import style0 from "./DimEditTable.vue?vue&type=style&index=0&id=6b9a6bd2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports